<section id="steps-amazon-section" class="feat-pro2 bg-white mt-xl-4 pt-md-4 pt-xl-5 pb-2">
  <div class="container flex-column justify-content-between px-0 d-flex">
    <div class="row">
      <div class="col-md-12 d-flex justify-content-center">
        <p class="h2 p-2 font-weight-bold text-center section-title">¿Cómo comprar en Walmart y enviar a Cuba?</p>
      </div>
    </div>

    <div class="d-flex flex-column flex-md-row justify-content-between mt-md-5">
      <div class="d-flex flex-column align-items-center align-items-center mx-4 p-4 py-md-2 step-item-container">
        <img width="300" height="393" class="d-none d-md-block d-lg-none" src="assets/market-walmart/mobile.png">
        <img width="400" height="525" class="d-none d-lg-block" src="assets/market-walmart/mobile.png">
        <img width="300" height="393" class="d-block d-md-none" src="assets/market-walmart/mobile.png">
      </div>
      <div class="d-flex flex-column">
        <div class="d-flex flex-column align-items-center flex-md-row mx-lg-4 p-4 py-md-2 step-item-container">
          <img width="74" height="63" class="d-block d-md-none" src="assets/market-shein/market.svg">
          <img width="50" height="42" class="d-none d-md-block d-lg-none" src="assets/market-shein/market.svg">
          <img width="74" height="63" class="d-none d-lg-block" src="assets/market-shein/market.svg">
          <p class="pl-md-4 text-center text-md-left mt-3" style="color: #212B36">1. Selecciona la tienda Walmart.</p>
          <div class="divider w-100 my-4 d-block d-md-none" style="border: 1px solid; opacity: .4"></div>
        </div>
        <div class="d-flex flex-column align-items-center flex-md-row mx-lg-4 p-4 py-md-2 step-item-container">
          <img width="72" height="72" class="d-block d-md-none" src="assets/market-shein/search.svg">
          <img width="54" height="54" class="d-none d-md-block d-lg-none" src="assets/market-shein/search.svg">
          <img width="72" height="72" class="d-none d-lg-block" src="assets/market-shein/search.svg">
          <p class="pl-md-4 text-center text-md-left mt-3" style="color: #212B36">2. Elige el producto a través del buscador
            o pega directamente el enlace</p>
          <div class="divider w-100  my-4 d-block d-md-none" style="border: 1px solid; opacity: .4"></div>
        </div>
        <div class="d-flex flex-column align-items-center flex-md-row mx-lg-4 p-4 py-md-2 step-item-container">
          <img width="88" height="79" class="d-block d-md-none" src="assets/market-shein/air.svg">
          <img width="62" height="59 " class="d-none d-md-block d-lg-none" src="assets/market-shein/air.svg">
          <img width="88" height="79" class="d-none d-lg-block" src="assets/market-shein/air.svg">
          <p class="pl-md-4 text-center text-md-left mt-3" style="color: #212B36">3. Selecciona tu método de envío (aéreo o marítimo)</p>
          <div class="divider w-100  my-4 d-block d-md-none" style="border: 1px solid; opacity: .4"></div>
        </div>
        <div class="d-flex flex-column align-items-center flex-md-row mx-lg-4 p-4 py-md-2 step-item-container">
          <img width="80" height="73" class="d-block d-md-none" src="assets/market-shein/payment.svg">
          <img width="66" height="60" class="d-none d-md-block d-lg-none" src="assets/market-shein/payment.svg">
          <img width="80" height="73" class="d-none d-lg-block" src="assets/market-shein/payment.svg">
          <p class="pl-md-4 text-center text-md-left mt-3" style="color: #212B36">4. Paga tu pedido y valida tu orden una vez llegada a nuestros almacenes</p>
        </div>
      </div>
    </div>
  </div>
</section>
<ng-template #snippet>
  <div class="backdrop" style="border-radius: 25px">
    <div class="snippet" data-title="dot-pulse">
      <div class="stage">
        <div class="dot-pulse"></div>
      </div>
    </div>
  </div>
</ng-template>
